import { useMutation } from '@tanstack/react-query';
import { deleteLeagueUser } from 'api/delete-league-user';
import { deleteMedibankUser } from 'api/delete-medibank-user';
import { isAccountDeletionDisabled } from 'common/env';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { PATIENT_PORTAL_SYSTEM_UUIDS } from 'types/patient-portal-system.types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mockMutationFn = (_userId: string): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(() => resolve(), 2000);
  });

export function useDeleteAccount() {
  const { systemId } = usePatientPortalContext();
  const systemUuid = PATIENT_PORTAL_SYSTEM_UUIDS[systemId];
  return useMutation({
    mutationFn: async (userId: string) => {
      if (isAccountDeletionDisabled()) {
        await mockMutationFn(userId);
        return;
      }
      await deleteMedibankUser(systemUuid);
      await deleteLeagueUser(userId);
    },
  });
}
